import React, { useContext, useState } from 'react';
import { Redirect } from 'react-router-dom';
import dayjs from 'dayjs';
import ResourceIndex from '../Shared/ResourceIndex/ResourceIndex';
import RolesContext from '../../contexts/RolesContext';
import { Modal } from '@stormwater-software/lib-ui';
import AppContext from '../../contexts/AppContext';
import InspectionTemplateCopy from '../LegendItems/Form/InspectionTemplateCopy';
import InspectionTemplateForm from './Forms/InspectionTemplateDetailsForm';

const InspectionTemplates: React.FC = () => {
  const rolesContext = useContext(RolesContext);
  const appStore = useContext(AppContext);
  const [showArchived, setShowArchived] = useState(false);

  const user = appStore.get('user');

  const getDiviId = window.location.pathname.split('/');

  return (
    <React.Fragment>
      <ResourceIndex
        resourceName={showArchived ? 'archivedInspectionTemplates' : 'inspectionTemplates'}
        resourceTableHeaders={[
          ['Name', 'name'],
          ...(showArchived
            ? [['Archived On', 'archivedAt'] as [string, string]]
            : []),
        ]}
        resourceSearchProps={['name']}
        resourceQueryProps={{ divisionId: getDiviId[2] }}
        enableRead={rolesContext.userHasPermission(
          'read',
          'Inspection Templates',
        )}
        enableClick={rolesContext.userHasPermission(
          'update',
          'Inspection Templates',
        )}
        enablePagination={false}
        enableCallToAction={
          !showArchived &&
          rolesContext.userHasPermission('create', 'Inspection Templates')
        }
        enableSelectAll={
          !showArchived &&
          (user.roleName === 'Super Admin' || user.roleName === 'Admin')
        }
        callToActionContent={'Inspection Template'}
        extraHeaderActions={
          rolesContext.userHasPermission('update', 'Inspection Templates') ? (
            <button
              className='outline'
              onClick={() => setShowArchived((prev) => !prev)}
            >
              {showArchived ? 'Show Active' : 'Show Archived'}
            </button>
          ) : undefined
        }
        renderRowCell={(row: any, propName: string) => {
          const value = row[propName];

          if (propName === 'name' && showArchived) {
            return (
              <span>
                {value}{' '}
                <span
                  style={{
                    fontSize: '0.75rem',
                    background: '#e0e0e0',
                    color: '#555',
                    borderRadius: '3px',
                    padding: '1px 6px',
                    marginLeft: '6px',
                  }}
                >
                  Archived
                </span>
              </span>
            );
          }

          if (propName === 'archivedAt' && value) {
            return dayjs(value).format('MM-DD-YYYY');
          }

          return value;
        }}
        renderReader={(inspectionTemplate, handleClose) => {
          if (!inspectionTemplate.isUserTemplate) {
            return (
              <Modal
                show={true}
                handleSubmit={handleClose}
                handleClose={handleClose}
                title='Error'
                subTitle='System Templates can not be edited at this time.'
              />
            );
          } else {
            return (
              <Redirect
                push
                to={`/divisions/${getDiviId[2]}/inspection-templates/${inspectionTemplate.id}`}
              />
            );
          }
        }}
        renderCallToAction={(
          handleClose,
          pushData,
          _refetch,
          setSelectedItems,
          selectedItems,
        ) => {

          if (selectedItems.length > 0) {
            return (
              <InspectionTemplateCopy
                onSubmit={(data: any) => {
                  pushData(data);
                  setSelectedItems([]);
                  handleClose();
                }}
                onCancel={handleClose}
                selectedItems={selectedItems}
                role={user.roleName}
              />
            );
          } else {
            return (
              <InspectionTemplateForm
                title='Add Inspection Template'
                handleClose={handleClose}
              />
            );
          }
        }}
        hideCallToActionInMobile={false}
      />
    </React.Fragment>
  );
};

export default InspectionTemplates;
